const fieldLinkages = {
  field_he_pctraceunknown: {
    constraintType: 'PERCENT',
    fields: [
      'field_he_pctafricanam',
      'field_he_pcthispanic',
      'field_he_pctnativepacificisland',
      'field_he_pcttwoormoreraces',
      'field_he_pctcaucasian',
      'field_he_pctasian',
      'field_he_pctnativeam',
    ],
  },
};

export default fieldLinkages;
